

































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { certificationForm } from '@/constants/applyForm'
import Uploader from '@/utils/uploads'
import FormItem from '@/components/form-item/index.vue'
import MTextarea from '@/components/m-textarea/index.vue'
import SelectItem from '@/components/Select.vue'
import { applySubmit, getCertifiInfo } from '@/services/apply'
import { CHECK_STATUS } from '@/constants/applyForm'
import { Dialog } from 'element-ui'
import Popup from '@/components/popup/index.vue'

@Component({
  components: {
    FormItem,
    MTextarea,
    SelectItem,
    Dialog,
    Popup,
  },
})
export default class Certification extends Vue {
  btnTxt: string = '下一步'
  formData: ApplyTypes.CertificationForm = certificationForm
  positiveImg: string = '' // 正面照
  obverseImg: string = '' // 反面照
  imgPreview = {
    positiveImg: '', // 正面照
    obverseImg: '', // 反面照
  }
  showBtn: Boolean = true
  inputDisable: Boolean = false
  $toast: any
  dialogFormVisible: Boolean = false
  CHECK_STATUS = CHECK_STATUS
  certifiSuccess: Boolean = false
  verifiVisible: Boolean = false
  certifiMsg: string = '' // 认证失败信息
  uploadTag: Set<string> = new Set()

  certificateTypeOptions = [
    {
      label: '身份证',
      value: '0',
    },
  ]

  @Prop({ type: Boolean, default: false })
  inBuffer!: boolean

  @Prop({ type: Boolean, default: false })
  noVerifi!: boolean

  get userInfoInapp() {
    return this.$store.state.userInfoInapp
  }

  get checkStatus() {
    // if (this.userInfo.extInfo && !isNaN(this.userInfo.extInfo.settledStatus)) {
    //   return this.userInfo.extInfo.settledStatus
    // }
    // return this.CHECK_STATUS.NOT_APPLY

    if (this.userInfo && !isNaN(this.userInfo.accountState)) {
      // 判断入驻状态
      if (this.userInfo && this.userInfo.accountState != 0) {
        if (
          this.userInfo.accountType === 1 &&
          this.userInfo.accountState === 2
        ) {
          this.noVerifi = false // 通过实名认证: 是
        } else {
          this.noVerifi = true // 通过实名认证: 否
        }
        return this.userInfo.accountState
      }
      // 判断是否入驻分账剧品类
      if (this.userInfo && this.userInfo.partnerState === 2) {
        return this.CHECK_STATUS.ISPARTNER
      }
    }
    return this.CHECK_STATUS.NOT_APPLY
  }

  get userInfo() {
    return this.$store.state.userInfo
  }

  get certificateImg() {
    if (!this.positiveImg || !this.obverseImg) return ''
    return `${this.positiveImg},${this.obverseImg}`
  }

  // 提交申请
  apply() {
    if (!this.formData.actualName) {
      return this.$toast('请输入姓名')
    }

    if (!this.formData.idCardNumber) {
      return this.$toast('请输入证件号')
    }

    if (
      !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(
        this.formData.idCardNumber
      )
    ) {
      return this.$toast('请输入有效证件号')
    }

    if (!this.certificateImg) {
      return this.$toast('请上传完整的证件照')
    }

    if (!this.formData.bankCard) {
      return this.$toast('请输入银行卡号')
    }
    this.formData.bankCard = this.formData.bankCard.replace(/ /g, '')
    if (!/^1[3|4|5|7|8|6|9]\d{9}$/.test(this.formData.mobile)) {
      return this.$toast('请输入正确的手机号')
    }

    this.$toast('loading...')
    this.submit()
  }

  async submit() {
    try {
      let data = {
        ...this.formData,
        uuid: this.userInfoInapp.uuid,
        idCardFront: this.certificateImg.split(',')[0], // 证明照片正片
        idCardRear: this.certificateImg.split(',')[1], // 证明照片反片
      }
      // console.log(1111, data, this.certificateImg, this.positiveImg)
      if (this.uploadTag.size > 0) {
        if (this.uploadTag.has('positiveImg') && data.idCardFront) {
          let url = new URL(data.idCardFront)
          data.idCardFront = url.pathname
        }
        if (this.uploadTag.has('obverseImg') && data.idCardRear) {
          let url = new URL(data.idCardRear)
          data.idCardRear = url.pathname
        }
      }
      const res = await applySubmit(data)
      if (res && res.code == 200) {
        this.uploadTag.clear()
        // 实名认证成功
        this.certifiSuccess = true

        const { uuid, ticket } = this.userInfoInapp
        this.$store.dispatch('getColumnistInfoAction', { uuid, ticket })
      } else {
        // 实名认证失败
        this.certifiSuccess = false
        this.certifiMsg = res.msg
        // this.$toast(res.msg)
      }
      this.verifiVisible = true
    } catch (error) {
      console.log(error)
    }
  }

  // 上传正面照
  onPositiveChange(e: Event) {
    this.uploadImg(e, 'positiveImg')
  }

  // 上传反面照
  onObverseChange(e: Event) {
    this.uploadImg(e, 'obverseImg')
  }

  // 上传图片
  uploadImg(e: Event, type: 'positiveImg' | 'obverseImg') {
    const target: HTMLInputElement = e.target as HTMLInputElement
    const files: FileList | null = target.files
    if (files && files.length) {
      const fileMaxSize = 1024 * 5 //最大5M
      const size = files[0].size / 1024
      if (size > fileMaxSize) {
        this.$toast('请上传5M以内的图片,请重新选择')
        target.value = ''
        return
      }

      // const { uuid, ticket } = this.userInfoInapp
      const PositiveUploader: any = new Uploader({
        file: files,
      })
      this.imgPreview[type] = URL.createObjectURL(files[0])

      PositiveUploader.on('success', (info: any) => {
        ;(this as any)[type] = info.url
        this.uploadTag.add(type)
      })
    }
  }

  beforeMount() {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
  }

  mounted() {
    if (this.checkStatus === CHECK_STATUS.GETTED && !this.noVerifi) {
      this.getCertiInfo()
    }
  }

  async getCertiInfo() {
    const res = await getCertifiInfo({
      uuid: this.userInfoInapp.uuid,
    })
    if (res.code === 200) {
      if (res.data && res.data.name !== '') {
        let resData = res.data
        // 银行卡号 ** 处理
        if (resData.accountState == 2) {
          this.formData.bankCard = this.encryptNum(resData.bankCardNumber, 0, 4)
          this.formData.idCardNumber = this.encryptNum(
            resData.idCardNumber,
            1,
            1
          )
          this.formData.mobile = this.encryptNum(resData.mobile, 3, 0)
          this.showBtn = false
          this.inputDisable = true
        } else {
          this.formData.bankCard = resData.bankCardNumber
          this.formData.idCardNumber = resData.idCardNumber
          this.formData.mobile = resData.mobile
          this.showBtn = true
          this.inputDisable = false
        }
        // this.formData.certificateType = resData.certificateType.toString()
        this.formData.actualName = resData.nickname
        this.imgPreview.positiveImg = resData.idCardFront
        this.imgPreview.obverseImg = resData.idCardRear
        this.positiveImg = resData.idCardFront
        this.obverseImg = resData.idCardRear
        // this.positiveImg = resData.certificateImg.split(',')[0]
        // this.obverseImg = resData.certificateImg.split(',')[1]
        // this.inputDisable = true
      }
    }
  }

  // 号码 ** 处理
  encryptNum(num: any, frontLen: any, endLen: any) {
    var len = num.length - frontLen - endLen
    var xing = ''
    for (var i = 0; i < len; i++) {
      xing += '*'
    }
    return (
      num.substring(0, frontLen) +
      xing +
      num.substring(num.length - endLen, num.length)
    )
  }

  goBack() {
    // this.dialogFormVisible = false
    this.getCertiInfo()
    this.verifiVisible = false
  }
}
